import axios from 'axios';
import { atom, type Atom } from 'jotai';

import { getConfig } from '../../../../../config';
import { JSON_CONTENT_TYPE } from '../../../../state/graphqlEndpoints';

// Types
export interface RelationshipAlias {
	name: string;
	isLatest: boolean;
	deprecated: boolean;
	inverse: boolean;
	isAliasExternallyAvailable: boolean;
	isHiddenFromGraphQLSchema: boolean;
}

export interface Relationship {
	fromType: string[];
	targetType: string[];
	ownerInfo: {
		pointOfContact: string;
		team: string;
		opsgenieTeamId: string;
	};
	permissionCheck: Record<string, any>;
	hidden: boolean;
	availableIn: string[];
	sendsAnalytics: string;
	sendsToFlock: boolean;
	category: string;
	id: string;
	name: string;
	version: string;
	deleted: boolean;
	fromTypeName: string[];
	targetTypeName: string[];
	providerType: {
		source: string[];
		target: string[];
	};
	isRelationshipExternallyAvailable?: boolean;
	aliases?: RelationshipAlias[];
}

// Always use the direct URL - CORS should be handled by browser extension or server config
const getRelationshipsEndpoint = () => {
	return getConfig().graphStoreUrl + '/api/relationship-types/registered-types.json';
};

export const relationshipsAsyncAtom: Atom<Promise<Record<string, Relationship>>> = atom(
	async () => {
		const endpoint = getRelationshipsEndpoint();
		const response = await axios.get<Record<string, Relationship>>(endpoint, {
			headers: {
				'Content-Type': JSON_CONTENT_TYPE,
			},
			withCredentials: true,
		});
		return response.data;
	},
);
